<template>
  <div>
    <div class="resbox">
      <div class="up">
        <img class="img" src="../../../assets/img/success.png" alt />
        <div class="res">恭喜，支付成功</div>
        <div class="back">
          您的订单已购买，请返回
          <span class="home" @click="goHome">数据库首页</span>继续使用
        </div>
        <div class="btns">
          <el-button
            style="background: #ff6908; color: #feede2; border-color: #ff6908;"
            @click="goDatabase"
          >进入数据库</el-button>
          <el-button style="color: #aaaaaa" @click="goOrderDetail">查看订单详情</el-button>
        </div>
      </div>
      <div class="tip">温馨提示：如遇支付成功后，系统权限无法正常使用，请与客服人员联系</div>
      <div class="contact">客服电话：010-65185898 | +86 15210925572</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  components: {},
  props: ["jumpUrl"],
  computed: {
    ...mapState(["authorization", "userInfo"])
  },
  created() {},
  methods: {
    goOrderDetail() {
      this.dialogVisible = false;
      this.$emit("showDialog", 4);
    },
    goHome() {
      // 进入数据库首页
      let url;
      if (process.env.NODE_ENV == "production") {
        url = `http://lightdata.tjresearch.cn/#/macro?userInfo=${JSON.stringify(
          this.userInfo
        )}&auth=${encodeURIComponent(this.authorization)}&moduleId=2`;
      } else {
        url = `http://macro.tj.cn/#/macro?userInfo=${JSON.stringify(
          this.userInfo
        )}&auth=${encodeURIComponent(this.authorization)}&moduleId=2`;
      }
      window.open(url);
    },
    goDatabase() {
      let url = `${this.jumpUrl}?userInfo=${JSON.stringify(
        this.userInfo
      )}&auth=${encodeURIComponent(this.authorization)}&moduleId=2`;
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.resbox {
  text-align: center;
  .up {
    margin-bottom: 80px;
    .code {
      width: 100px;
      height: 100px;
    }
    .res {
      font-weight: 500;
      font-size: 24px;
      margin: 20px;
      color: #414141;
    }
    .back {
      color: #999999;
      font-size: 12px;
      margin-bottom: 20px;
      .home {
        color: #ff6908;
        cursor: pointer;
      }
    }
    .btns {
      .el-button {
        width: 130px;
        height: 26px;
        line-height: 0;
        font-size: 12px;
      }
    }
  }
  .tip {
    height: 44px;
    line-height: 44px;
    margin: 0 50px;
    color: #aa956e;
    background: #fbf8e5;
    border: 1px solid #f0f0ec;
    font-size: 12px;
  }
  .contact {
    margin-top: 30px;
    font-size: 12px;
  }
}
</style>